import { render, staticRenderFns } from "./traineeship_programmes.vue?vue&type=template&id=bcc8ea46&scoped=true&"
import script from "./traineeship_programmes.vue?vue&type=script&lang=js&"
export * from "./traineeship_programmes.vue?vue&type=script&lang=js&"
import style0 from "./traineeship_programmes.vue?vue&type=style&index=0&id=bcc8ea46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc8ea46",
  null
  
)

export default component.exports